// extracted by mini-css-extract-plugin
module.exports = {"skeletonSection":"styles_skeletonSection__m_4ML","headline":"styles_headline__ZtLPq","productsWrapper":"styles_productsWrapper__KRcBc","linkWrapper":"styles_linkWrapper__6SMLD"};